module.exports = __webpack_public_path__ + "static/mary-kay-logo-f1a0d210d82751b28f42c73fe6436181.png";